/**
 * 全局双语开关（环境变量 VUE_APP_ENABLE_ENGLISH）
 * true / 未配置 → 显示英文副文案
 * false / 0 / off → 仅中文
 */
function parseEnableEnglish(val, defaultValue = true) {
  if (val === undefined || val === null || val === '') return defaultValue
  const n = String(val).trim().toLowerCase()
  return n !== 'false' && n !== '0' && n !== 'off'
}

export const ENABLE_ENGLISH = parseEnableEnglish(process.env.VUE_APP_ENABLE_ENGLISH, true)
